var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41 1.923a.57.57 0 0 0-.816 0L2.656 6.048a.562.562 0 0 0 .813.776l2.97-3.108v7.972c0 .311.25.562.563.562.311 0 .562-.25.562-.562V3.715l2.967 3.11a.562.562 0 0 0 .814-.775L7.407 1.926z"
  })));
};
export default SvgArrowUp;